import { useSelector, useDispatch } from "react-redux";
import { actions as debinActions } from "reducers/debin";

const useGetDebinAccounts = () => {
    const dispatch = useDispatch();
    const { accounts, fetching } = useSelector((state) => state.debin);

    const fetchAccounts = () => {
        dispatch(debinActions.debinPreActivity());
    };

    return { debinAccounts: accounts, fetching, fetchAccounts };
};

export default useGetDebinAccounts;
